import { makeStyles } from '@material-ui/core';

export const usePopoverTooltipStyles = makeStyles((theme) => ({
  arrow: {
    color: '#007DB8',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  tooltip: {
    backgroundColor: '#007DB8',
    borderRadius: '8px',
    padding: '16px',
    color: 'var(--white)',
    [theme.breakpoints.down('sm')]: {
      position: 'fixed !important',
      bottom: '0px !important',
      width: '100vw !important',
      maxWidth: '100vw !important',
      margin: '0px !important',
      paddingTop: '40px'
    }
  },
  popper: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed !important',
      bottom: '0px !important',
      width: '100vw !important',
      marginLeft: '0px !important',
      transform: 'none !important'
    }
  }
}));

export const usePopoverTooltipAddonStyles = makeStyles((theme) => ({
  mobileBackdrop: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      position: 'fixed',
      top: '0px',
      height: '100vh',
      width: '100vw',
      zIndex: '9999',
      marginLeft: '-30px'
    }
  },
  mobileClose: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      border: '6px solid #FFF',
      backgroundColor: '#33BBEF',
      display: 'inline-block',
      fontSize: '18px',
      borderRadius: '50%',
      padding: '10px',
      fontWeight: 'bold',
      position: 'absolute',
      marginTop: '-60px',
      marginLeft: 'calc(50% - 40px)',
      cursor: 'pointer'
    }
  }
}));

export const  usePopoverTooltipElementStyles = makeStyles(() => ({
  popoverTooltipElement: {
    borderBottom: '1px dashed',
    cursor: 'pointer'
  },
  popoverTooltipTextHeading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
    margin: '0px 0px 8px 0px'
  },
  popoverTooltipTextContent: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    margin: '0px 0px 8px 0px'
  },
  popoverTooltipTextList: {
    padding: '5px 0px 0px 16px',
    margin: '0px'
  },
  contents: {
    margin: '15px 0'
  },
  breakLine: {
    marginBottom: '10px'
  }
}));